import { useEffect } from "react";

// Google Ads "WhatsApp Enquiry" conversion (click-based). Uses the already
// installed base tag AW-18404975088 — never loads gtag.js itself.
const SEND_TO = "AW-18404975088/XItKCOaOguwcEPDDlshE";

export const WhatsAppConversionTracker = () => {
  useEffect(() => {
    const onClick = (e) => {
      const el = e.target instanceof Element ? e.target : null;
      const a = el ? el.closest('a[href*="wa.me/"]') : null;
      if (!a) return;
      if (window.location.pathname.startsWith("/admin")) return;
      if (typeof window.gtag === "function") {
        window.gtag("event", "conversion", { send_to: SEND_TO });
      }
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
  return null;
};

export default WhatsAppConversionTracker;
